// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VSyq","right":"styles_right__3rxKU"};